import React, { useContext } from "react";
import { useRadio, useRadioGroup, HStack, Box, FormLabel } from "@chakra-ui/react";

import { PreferredUnitsContext } from "../../contexts/PreferredUnitsContext";
import { UNIT_SYSTEMS } from "../../../utils/constants";

const RadioCard = (props) => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderRadius="99px"
        _checked={{
          bg: "teal.100",
          color: "black",
          borderColor: "teal.100",
        }}
        _hover={{
          bg: "teal.200",
        }}
        px={4}
        py={3}
        style={{
          textTransform: "capitalize",
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export const UnitSystemToggle = () => {
  const [preferredUnitSystem, updatePreferredUnitSystem] = useContext(PreferredUnitsContext);
  const options = Object.values(UNIT_SYSTEMS)

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "preferred-unit-system",
    defaultValue: preferredUnitSystem,
    onChange: (value) => updatePreferredUnitSystem(value),
  });

  const group = getRootProps();

  return (
    <Box mt={50}>
      <FormLabel mb={4}>Units</FormLabel>
      <HStack {...group}>
        {options.map((value) => {
          const radio = getRadioProps({ value });
          return (
            <RadioCard key={value} {...radio}>
              {value}
            </RadioCard>
          );
        })}
      </HStack>
    </Box>
  );
};
